import React from 'react';
import { GenericFormPage } from '../../../components/generic';
import { useManagementCompany, ManagementCompany } from './useData';
import { moduleConfig, getInitialFormData, mapItemToFormData } from './config';
import { ManagementCompanyLogoPanel } from './LogoPanel';

const Form: React.FC = () => (
  <GenericFormPage<ManagementCompany>
    useData={useManagementCompany}
    config={{
      ...moduleConfig,
      getInitialFormData,
      mapItemToFormData,
      renderEditFormExtra: ({ isEdit, data, id }) => {
        if (!isEdit || !id || !data) {
          return (
            <p className="mt-3 text-xs text-slate-500">
              Save the management company first, then upload a logo on edit or detail.
            </p>
          );
        }
        return (
          <div className="mt-4">
            <ManagementCompanyLogoPanel
              companyId={id}
              logoStorageKey={data.logoStorageKey}
              logoOriginalFilename={data.logoOriginalFilename}
              editable
            />
          </div>
        );
      },
    }}
  />
);

export default Form;
